const refs = {
  body: document.querySelector('body'),
  mainList: document.querySelector('.movieList'),
};

export default refs;
